module.exports = __webpack_public_path__ + "img/Debbie_King@2x.b2b6dfc6.webp";